import { Suspense, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { PageLoader } from "@/components/ui/loading-skeletons";

interface SuspenseBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Wrapper around React.Suspense with a default loading fallback
 */
export function SuspenseBoundary({ 
  children, 
  fallback = <PageLoader /> 
}: SuspenseBoundaryProps) {
  return <Suspense fallback={fallback}>{children}</Suspense>;
}

/**
 * Default inline loading indicator component
 */
function InlineLoadingIndicator() {
  const { t } = useTranslation('common');
  return <div className="animate-pulse">{t('common.loading', 'Loading...')}</div>;
}

/**
 * Inline suspense boundary for smaller components
 * Uses a minimal loading indicator
 */
export function InlineSuspense({ 
  children, 
  fallback 
}: SuspenseBoundaryProps) {
  return (
    <Suspense fallback={fallback || <InlineLoadingIndicator />}>
      {children}
    </Suspense>
  );
}
